export const version = 'v5.4.0';
export const buildDate = '2026-05-13T00:04:42.644Z';
export const commitHash = 'b1d8e83';